import { useState, useContext } from "react";
import getCurrentSkin from "../utils/getCurrentSkin";

import TopbarMobile from "../components/TopbarMobile";
import { ThemeContext } from "../context/ThemeContext";
import PayRollSidebar from "./PayRollSidebar";

const PayRollLayoutWrapper = ({ children }) => {
  const { isDark, skin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div
      className={`${
        isDark ? "bg-neutral-900 text-white" : "bg-gray-100 text-black"
      } flex min-h-screen relative w-full overflow-x-clip`}
    >
      {/* Mobile Topbar */}
      <TopbarMobile onOpenSidebar={() => setSidebarOpen(true)} />

      {/* Sidebar */}
      <PayRollSidebar
        isMobileOpen={isSidebarOpen}
        onCloseMobile={() => setSidebarOpen(false)}
      />

      {/* Main Content: min-w-0 lets this flex item shrink below its content width */}
      <main className="flex-1 min-w-0 flex justify-center items-start sm:p-6 p-4 pt-20 sm:pt-6">
        <div
          className={`w-full min-w-0 max-w-[1400px] shadow-2xl min-h-screen p-4 sm:p-8 rounded-tr-[3rem] rounded-br-[3rem] overflow-x-clip ${
            isDark ? currentSkin.darkContent : currentSkin.content
          }`}
        >
          {children}
        </div>
      </main>
    </div>
  );
};

export default PayRollLayoutWrapper;